module.exports = __webpack_public_path__ + "assets/media/day15.6bc511c5.mp3";